import { Loader } from 'shared/components/Loader'
import React, { useCallback, useEffect, useState } from 'react'
import { Base64 } from 'js-base64'
import WebFont from 'webfontloader'
import { SURVEY_FONTS, includeWeightOfFont } from 'organisms/BrandSettings'
import constants from 'config/constants'

export default function WebEmbedPreview() {
  const [loading, setLoading] = useState(true)

  const loadScript = useCallback((src) => {
    return new Promise(function (resolve, reject) {
      const script = document.createElement('script')
      script.src = src
      // This ID is hard-coded
      script.id = 'simplesat-web-embed'
      script.addEventListener('survey-loaded', function () {
        resolve(script)
      })
      script.addEventListener('error', function (error) {
        reject(error)
      })
      document.body.appendChild(script)
    })
  }, [])

  const initialStyle = window.location.search.split('init=')[1]
  const previewStyle = Base64.decode(initialStyle)

  const triggerShowSurvey = useCallback(() => {
    // @ts-ignore
    window.simplesat.survey({
      survey_token: constants.webEmbedPreviewSurveyToken,
      preview: true,
      customer: {
        email: 'tester@example.com',
      },
      previewStyle: previewStyle,
    })
  }, [previewStyle])

  useEffect(() => {
    const url = constants.webEmbedScriptURL
    const scriptPromise = loadScript(url)

    let script
    scriptPromise
      .then(function (loadedScript) {
        script = loadedScript

        triggerShowSurvey()
        setLoading(false)
      })
      .catch(function (error) {
        setLoading(false)
        throw error
      })

    return () => {
      if (script) {
        document.body.removeChild(script)
      }
    }
  }, [loadScript, setLoading, triggerShowSurvey])

  useEffect(() => {
    WebFont.load({
      google: {
        families: SURVEY_FONTS.map(includeWeightOfFont),
      },
    })
  }, [])

  if (loading) {
    return <Loader />
  } else {
    return <div className="!bg-white !h-full" />
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Brands/WebEmbedPreview/index.js